module.exports = __webpack_public_path__ + "static/media/speaker_polyu_DanWang.5957620c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_polyu_DanWang.jpg
// module id = 244
// module chunks = 0